import {
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import PhoneIphoneIcon from "../../../assets/icons/global-icon-device-sim.svg";
import DesktopIcon from "../../../assets/icons/global-icon-computer-black.svg";
import BrandGlobalIcon from "../../../assets/icons/Brand_Global_APIs_Icon.svg";
import AlexaIcon from "../../../assets/icons/alexa-icon.svg";
import "./index.scss";
// import { useSelector } from 'react-redux'
// import { RootState } from 'app/reducers'

export interface LineCollapseProps {
  deviceList: Array<any>;
  owner: string;
  keyData: any;
  open: boolean;
  onDeactivate: (deviceId: string, id: string) => void;
}

export default function LineCollapse(props: LineCollapseProps) {
  const { open, onDeactivate, keyData, deviceList, owner } = props;
  // const primaryDeviceList = useSelector((state: RootState) => state.lineDelve.primaryDevice)

  // const isPrimaryDevice = (id: string) => {
  //   return primaryDeviceList.some((item) => item.deviceId === id)
  // }

  const getPrimaryText = (item: any) => {
    if (owner !== item.ownerId) {
      return "";
    } else {
      return "Deactivate line";
    }
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (typeof ele === "string") {
      const targetEle: any = document.querySelector("#" + ele);
      if (event.keyCode === 9) {
        // targetEle.nextSibling.querySelector('span').focus()
      }
      if (event.keyCode === 13) {
        targetEle.click();
      }
    } else {
      if (event.keyCode === 13) {
        ele.current.click();
      }
    }
  };

  // const getPrimaryText = (item: any) => {
  //   if (owner !== item.ownerId) {
  //     return isPrimaryDevice(item.deviceId) ? 'SIM Device, cannot deactivate' : 'cannot deactivate'
  //   } else {
  //     return isPrimaryDevice(item.deviceId) ? 'SIM Device, cannot deactivate' : 'Deactivate line'
  //   }
  // }

  // const getClassName = (item:any) => {
  //   if(owner !== item.ownerId) {
  //     if(isPrimaryDevice(item.deviceId)){
  //       return 'deactivate'
  //     }
  //     return '';
  //   } else {
  //     return 'deactivate';
  //   }
  // }
  const getClassName = (item: any) => {
    if (owner !== item.ownerId) {
      return "";
    } else {
      return "deactivate";
    }
  };

  const categoryIcon = (category:string) => {
    switch(category) {
      case "cdigits":
        return PhoneIphoneIcon;
      case "webdigits":
        return DesktopIcon
      case "alexa":
        return AlexaIcon
      default:
        return BrandGlobalIcon;
    }
  }

  const categoryAltText = (category:string) => {
    switch(category) {
      case "cdigits":
        return "Phone Icon";
      case "webdigits":
        return "Desktop Icon";
      case "alexa":
        return "Alexa Icon"
      default:
        return "BrandGlobal Icon";
    }
  }
 

  return (
    <Collapse in={open} timeout="auto" unmountOnExit key={keyData}>
      <List>
        {deviceList.map((item: any, i: number) => {
          return (
            <React.Fragment key={i}>
              <ListItem
                secondaryAction={
                  <ListItemText
                    tabIndex={getPrimaryText(item) === "" ? -1 : 0}
                    primary={getPrimaryText(item)}
                    id={"device-collapse-" + i}
                    className={getClassName(item)}
                    onKeyDown={(event) =>
                      getPrimaryText(item) !== "" &&
                      handleKeyUp(event, "device-collapse-" + i)
                    }
                    onClick={() =>
                      owner === item.ownerId &&
                      onDeactivate(item.deviceId, keyData)
                    }
                  ></ListItemText>
                }
                key={item.deviceId}
              >
                <ListItemIcon>
                  <img
                    src={categoryIcon(item?.voiceOverWifiService?.applicationCategory?.toLowerCase())}
                    alt={categoryAltText(item?.voiceOverWifiService?.applicationCategory?.toLowerCase())}
                    width="40"
                    height="40"
                  />
                </ListItemIcon>
                <ListItemText
                  primary={item.deviceName}
                  className="devicename"
                  tabIndex={0}
                />
              </ListItem>
              <Divider variant="inset" component="li" key={i} />
            </React.Fragment>
          );
        })}
      </List>
    </Collapse>
  );
}
